<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <div style="float:right">
        <button type="button" class="btn btn-sm btn-default" style="float:right; border: 0" @click="removeElement"
                content="Element löschen" v-tippy>
          <i class="fa fa-close" style="color: black"></i>
        </button>
      </div>
      <label class="box-title">{{
          this.titles[isFeed() ? this.record.module : this.record.list_module].toString().toUpperCase()
        }}</label>
    </div>
    <div class="panel-body">
      <vue-toastr ref="notificationToast"></vue-toastr>
      <div class="ibox box-primary" style="margin-bottom: 0">
        <div class="ibox-content">
          <div class="form-group">
            <label>Interne Bezeichnung</label>
            <br>
            <input type="text"
                   class="form-control"
                   v-model="record.name">
          </div>
          <div class="form-group" v-if="isFeed() && !isModule(['FeedHeadlineModule', 'MagazineModule', 'UniversalSliderModule'])">
            <label>Anzeigename <a class="fa fa-question-circle" v-tippy
                                  content="Name, der über dem Modul im Feed in der App angezeigt wird."></a></label>
            <br>
            <input type="text"
                   class="form-control"
                   v-model="record.display_name">
          </div>

          <div class="form-group" v-if="isList()">
            <label>Modul</label>
            <br>
            <select class="form-control"
                    v-model="record.list_module">
              <option value="ListHeadline">Überschrift</option>
              <option value="ListSeparator">Separator</option>
              <option value="ListButton">Listenelement</option>
              <option value="ListLinkBox">Infobox</option>
              <option value="ListCustomerCard">Kundenkartenvorschau</option>
            </select>
          </div>

          <div class="form-group" v-if="isModule(['ListButton','ListLinkBox'])">
            <label>Art der Verlinkung</label>
            <select v-model="record.link_type" class="form-control"
                    style="margin-top: 5px">
              <option value="internal">Interne Verlinkung</option>
              <option value="external">Externe Verlinkung</option>
            </select>
          </div>

          <div class="form-group"
               v-if="isFeed() || isModule(['ListButton','ListLinkBox']) && record.link_type === 'internal'">
            <label>{{ appTabConfig.type === 'list' ? 'Interne Verlinkung' : 'Modul' }}</label>
            <br>
            <select class="form-control"
                    v-model="record.module">
              <option v-if="isFeed()" value="FeedHeadlineModule">Überschrift</option>
              <option value="NewsModule">News</option>
              <option value="MagazineModule">WKZ-Trendblog</option>
              <option value="CampaignsModule">Gutscheine, Bonus und Einladungen</option>
              <option value="PersonalShoppingModule">Personal Shopping</option>
              <option value="UniversalSliderModule">Info-Slider</option>
              <option v-if="isList()" value="ReceiptModule">Kassenbons</option>
              <option v-if="isList()" value="SettingsModule">Einstellungen</option>
              <option v-if="isList()" value="AccountModule">Stammdaten ändern</option>
              <option v-if="isList()" value="StaticInformationModule">Statische Informationsseite</option>
              <option value="AdvertisementModule">Marketing-Slider</option>
              <option value="StoreBranchesModule">Filialen</option>
            </select>
          </div>

          <div class="form-group"
               v-if="isModule(['MagazineModule']) || isInternalLink('MagazineModule')">
            <label for="">Kategorie</label>
            <Select2 v-model="record.category_id" :options="Categories"/>
          </div>

          <div class="form-group"
               v-if="isModule(['StaticInformationModule']) || isInternalLink('StaticInformationModule')">
            <label for="">Statische Informationsseite</label>
            <Select2 v-model="record.static_information_page_id" :options="StaticInformationPages"/>
          </div>

          <div class="form-group"
               v-if="isModule(['UniversalSliderModule']) || isInternalLink('UniversalSliderModule')">
            <label for="">Info-Slider</label>
            <Select2 v-model="record.universal_slider_id" :options="UniversalSliders"/>
          </div>

          <div class="form-group" v-if="isModule(['ListLinkBox', 'ListCustomerCard'])">
            <label>Überschrift</label>
            <br>
            <input name="title"
                   type="text"
                   id="title"
                   class="form-control"
                   v-model="record.title">
          </div>

          <div class="form-group" v-if="isModule(['FeedHeadlineModule','ListHeadline'])">
            <label>Textinhalt</label>
            <br>
            <input type="text"
                   class="form-control"
                   v-model="record.text">
            <br>
            <div v-if="isModule(['FeedHeadlineModule'])">
              <button @click="changeVariablesVisible" style="background: white; border: 0"><b>Variablen
                <span class="fa fa-chevron-down"></span></b>
              </button>
              <div v-for="key in Object.keys(customerVariables)" v-if="variablesVisible">
                <div style="width:300px; display: inline-block"><b>@kunde_{{ customerVariables[key] }}</b></div>
                {{ customerVariablesTranslations[key] }}
              </div>
            </div>
          </div>

          <div class=" form-group " v-if="isModule(['ListLinkBox'])">
            <label>Fließtext</label>
            <br>
            <input type="text"
                   class="form-control"
                   v-model="record.text">
          </div>

          <div class="form-group"
               v-if="isModule(['ListButton','ListLinkBox']) && record.link_type === 'external'">
            <label>Link</label>
            <br>
            <input type="text"
                   class="form-control"
                   v-model="record.external_link">
          </div>

          <div class="form-group" v-if="isModule(['ListButton', 'ListLinkBox'])">
            <label>Icon</label>
            <br>
            <icon-picker :model="record" :prop-name="'icon'"></icon-picker>
          </div>

          <div class="form-group"
               v-if="isModule(['NewsModule','MagazineModule','AdvertisementModule','CampaignsModule','PersonalShoppingModule','StoreBranchesModule'])">
            <label>Anzahl an Slidern, die im Feed angezeigt werden</label>
            <br>
            <input type="number"
                   class="form-control"
                   v-model="record.slider_count">
          </div>

          <div class="form-group"
               v-if="isModule(['NewsModule','MagazineModule','CampaignsModule'])">
            <input type="checkbox"
                   v-model="record.show_link">
            <label>Verlinkung auf Modul aktivieren</label>
          </div>

          <div v-if="isModule(['ListCustomerCard'])">
            <div class="form-group">
              <input type="checkbox"
                     v-model="record.show_title">
              <label>Titel anzeigen</label>
            </div>

            <div class="form-group">
              <input type="checkbox"
                     v-model="record.show_first_name">
              <label>Vorname anzeigen</label>
            </div>

            <div class="form-group">
              <input type="checkbox"
                     v-model="record.show_last_name">
              <label>Nachname anzeigen</label>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from "../common/modal/Modal";
import VueToastr from "vue-toastr";
import IconPicker from "../common/icon-picker/IconPicker.vue";

export default {
  name: 'AppTabConfigElementForm',
  components: {
    IconPicker,
    Modal,
    VueToastr
  },
  methods: {
    isModule(modules) {
      if (this.appTabConfig.type === 'list') return modules.includes(this.record.list_module);
      return modules.includes(this.record.module);
    },
    isInternalLink(module) {
      return this.isList() && this.record.module === module && this.record.link_type === 'internal';
    },
    isFeed() {
      return this.appTabConfig.type === 'feed';
    },
    isList() {
      return this.appTabConfig.type === 'list';
    },
    changeVariablesVisible() {
      this.variablesVisible = !this.variablesVisible;
    },
    removeElement() {
      this.appTabConfig.elements.splice(this.index, 1);
      this.$parent.$forceUpdate();
    },
    extractClientData(property, modelPropertyName) {
      try {
        let data = property[this.appTabConfig?.client_id];
        if (!data) return [];
        if (!this.record[modelPropertyName] && data[0]) {
          this.record[modelPropertyName] = data[0].id;
        }
        return data;
      } finally {
        this.$forceUpdate();
        this.$parent.$forceUpdate();
      }
    }
  },
  data() {
    return {
      variablesVisible: false,
      titles: {
        FeedHeadlineModule: 'Überschrift',
        AccountModule: 'Profil',
        NewsModule: 'News',
        CampaignsModule: 'Gutscheine, Bons und Einladungen',
        PersonalShoppingModule: 'Personal-Shopping',
        StoreBranchesModule: 'Filialen',
        MagazineModule: 'WKZ-Trendblog',
        UniversalSliderModule: 'Info-Slider',
        StaticInformationModule: 'Statische Informationsseite',
        AdvertisementModule: 'Marketing-Slider',
        ListHeadline: 'Überschrift',
        ListCustomerCard: 'Kundenkartenvorschau',
        ListSeparator: 'Separator',
        ListButton: 'Listenelement',
        ListLinkBox: 'Infobox'
      }
    };
  },
  computed: {
    Categories: function () {
      return this.extractClientData(this.categories, "category_id");
    },
    UniversalSliders: function () {
      return this.extractClientData(this.universalSliders, "universal_slider_id");
    },
    StaticInformationPages: function () {
      return this.extractClientData(this.staticInformationPages, "static_information_page_id");
    },
  },
  props: ['clients', 'isAdmin', 'record', 'index', 'appTabConfig', 'user', 'title', 'disabled', 'categories', 'universalSliders', 'staticInformationPages', 'customerVariables', 'customerVariablesTranslations']
}
</script>

<style scoped>
</style>
<style>
.ckeditor-wrapper .ck-content {
  min-height: 300px;
}

label {
  margin-bottom: 6px;
  margin-top: 9px;
}
</style>
